export default 
{
    "A": {
        "1" : {
            "answer": "Testman",
            "recommendation": "A recommendation"
        },
        "2" : {
            "answer": "666",
            "recommendation": "Eat more veggies"
        }
    },
    "B": {

    },
    "C": {

    },
    "D": {

    },
    "E": {

    },
    "F": {

    },
    "G": {

    },
    "H": {

    },
    "I": {
        "88" : {
            "answer": 
            {
                "id": "1",
                "display": "Yes"
            },
            "recommendation": "Yearly check required for cataracts"
        }
    },
    "J": {

    },
    "K": {

    },
    "L": {

    },
    "M": {

    },
    "N": {

    },
    "O": {

    },
    "P": {

    },
    "Q": {

    },
    "R": {

    },
    "S": {

    },
    "T": {

    },
    "U": {

    },
    "V": {

    },
    "W": {

    }

};

// Click 'Save' -> Generate list of newly-answered/edited questions -> Cross-reference that list with Recommendations.ks
// -> For every common question, append the recommendation for the answer (depending on the answer) to the Recommendation Qnaire
// OR -> If a common question exists, override the recommendations qnaire answer with a list of recommendations
// OR -> If an answer of the Recommendations Qnaire already exists, do nothing.


// WEBPACK FOOTER //
// ./src/components/Recommendations.js